import {
  ChangeDetectorRef,
  Component,
  forwardRef,
  OnInit
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { _HttpClient, SettingsService } from '@delon/theme';

import { SelectBaseComponent } from '../select-base';

@Component({
  selector: 'app-payment-select',
  templateUrl: './payment-select.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PaymentSelectComponent),
      multi: true
    }
  ]
})
export class PaymentSelectComponent
  extends SelectBaseComponent
  implements OnInit
{

  constructor(
    http: _HttpClient,
    cdr: ChangeDetectorRef,
    private settingsService: SettingsService
  ) {
    super(http, cdr);
  }

  ngOnInit(): void {
  }

  getUrl(searchValue: string): string {
    let filter = ``;
    if (searchValue) {
      const searchStr = searchValue.replaceAll("'", "''");
      filter = `(contains(docCode, '${encodeURIComponent(
        searchStr
      )}') or contains(payTo,'${encodeURIComponent(searchStr)}'))`;
    }
    let url = `api/payments/lookup?$expand=currency($select=code)&$top=20&$skip=0&$orderby=docCode desc`;
    if (filter) url += `&$filter=${filter}`;

    return url;
  }
}
